import { render } from "./MyAccount.vue?vue&type=template&id=2db7c9fe&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"

import "./MyAccount.vue?vue&type=style&index=0&id=2db7c9fe&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\muzeu.ro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db7c9fe"]])

export default __exports__